<div class="worker-item" ng-repeat="user in dashboard.usersWithoutTask">
    <a ui-sref="users.edit({id: user.id})">{{user.firstname}} {{user.lastname}}</a>
</div>